import React from 'react'

export const Workshops = () => {
  return (
    <div>Workshops</div>
  )
}
